const initialize = () => {
    const modalStop = document.getElementById('subscriptionStopModal');
    const listStop = document.querySelectorAll('.subscription-link-stop');
    const stopField = modalStop.querySelectorAll('#subscriptionInputModal')[0];
    const modalRenew = document.getElementById('subscriptionRenewModal');
    const listRenew = document.querySelectorAll('.subscription-link-renew');
    const renewField = modalRenew.querySelectorAll('#subscriptionRenewInputModal')[0];
    listStop.forEach((link) => {
        link.addEventListener('click', () => {
            stopField.value = link.getAttribute('data-id');
        });
    });

    listRenew.forEach((link) => {
        link.addEventListener('click', () => {
            renewField.value = link.getAttribute('data-id');
        });
    });

    const onCompanySelect = (selectedRadio) => {
        return true;
    };

    const radios = document.querySelectorAll('input[type=radio][name="id"]');
    radios.forEach((radio) => radio.addEventListener('change', onCompanySelect(radio)));
};
export default initialize;
